"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var track_1 = __importDefault(require("../../Common/utils/track"));
// Tracks card challenge triggered.
exports.trackChallengeTrigger = function (orderCartId) {
    return track_1["default"]("challenge_card", {
        checkpoint: 'checkout',
        order_cart_id: orderCartId,
        type: 'second_card_trigger'
    });
};
// Tracks contact support attempt.
exports.trackContactSupport = function (orderCartId) {
    return track_1["default"]("challenge_card", {
        checkpoint: 'checkout',
        order_cart_id: orderCartId,
        type: 'contact_support'
    });
};
// Tracks challenge dismiss.
exports.trackOnClose = function () {
    return track_1["default"]("challenge_card", {
        checkpoint: 'checkout',
        type: 'second_card_challenge_close'
    });
};
// Fires when user confirms through a click action.
var trackOnClick = function (orderCartId) {
    return track_1["default"]("challenge_card", {
        checkpoint: 'checkout',
        order_cart_id: orderCartId,
        type: 'second_card_verify_click'
    });
};
// Tracks success.
var trackOnSuccess = function (orderCartId) {
    return track_1["default"]("challenge_card", {
        checkpoint: 'checkout',
        order_cart_id: orderCartId,
        type: 'second_card_success'
    });
};
// Tracks failure.
var trackOnFailure = function (orderCartId, reason, message) {
    if (reason === void 0) { reason = ''; }
    if (message === void 0) { message = ''; }
    return track_1["default"]("challenge_card", {
        reason: reason,
        message: message,
        checkpoint: 'checkout',
        order_cart_id: orderCartId,
        type: 'second_card_failure'
    });
};
exports.verifyPaymentCardTracking = function (orderCartId) { return ({
    onClick: function () { return trackOnClick(orderCartId); },
    onFailure: function () { return trackOnFailure(orderCartId); },
    onSuccess: function () { return trackOnSuccess(orderCartId); }
}); };
